import { MOD_KEY } from '@/shared/shortcut-hint';

export const CALL_SHORTCUTS = {
    microphone: [['M'], [MOD_KEY, 'D']],
    camera: [['V'], [MOD_KEY, 'E']],
    screenShare: [['D']],
    hand: [['R']],
    chat: [['C']],
    participants: [['P']],
    layout: [['W']],
    fullscreen: [['S']],
    help: [['?']],
} satisfies Record<string, string[][]>;
